<template>
  <div>
    <component v-if="!isComponentLoading" :is="landingPageHome"></component>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LandingPageHome from "../components/landing-page/LandingPageHome.vue";
export default {
  components: { LandingPageHome },
  name: "LandingPage",
  data() {
    return {
      landingPageHome: LandingPageHome,
      isComponentLoading: false,
    };
  },
  async created() {
    this.resetAdminState();
  },
  watch: {
    $route: {
      immediate: true,
      async handler(newValue, oldValue) {
        try {
            let tenantid = sessionStorage.getItem("tenantId");
            let meetingTypeStorageKey = "meetingType#" + tenantid;
            let meetingType = localStorage.getItem(meetingTypeStorageKey);
            if (meetingType) this.setMeetingType(meetingType);
        } catch (error) {
          this.isComponentLoading = false;
        }
      },
    },
  },
  computed: {
    loaderText() {
      return this.$t("LoaderText");
    },
  },
  methods: {
    ...mapActions({
      setMeetingType: "meeting/setMeetingType",
      resetAdminState: "admin/resetState",
    }),
  },
};
</script>

